import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
var AgroHeaderTabs = withCssProps(function (_ref) {
  var tabs = _ref.tabs,
    tagManager = _ref.tagManager;
  var gtmTabClick = function gtmTabClick(subtitle) {
    var active = tabs.filter(function (tab) {
      return tab.active === true;
    });
    var tagManagerArgs = {
      dataLayer: {
        event: 'trackEvent',
        eventCategory: 'Navigation',
        eventAction: "Agrofy ".concat(subtitle, "-").concat(active[0].subtitle, " Switch button"),
        eventLabel: "Agrofy ".concat(subtitle)
      }
    };
    if (tagManager) {
      tagManager(tagManagerArgs);
    }
  };
  return /*#__PURE__*/React.createElement(HeaderTabs, {
    "data-cy": "AgroHeaderTabs"
  }, /*#__PURE__*/React.createElement(TabsArea, null, /*#__PURE__*/React.createElement(Content, null, tabs.map(function (item, idx) {
    return item.show ? /*#__PURE__*/React.createElement(Tab, {
      className: "".concat(item.active ? 'active' : ''),
      "data-cy": item.active ? 'active' : 'inactive',
      key: idx
    }, /*#__PURE__*/React.createElement(TabLink, {
      "data-cy": "tab-link",
      href: item.url,
      onClick: function onClick() {
        return gtmTabClick(item.subtitle);
      }
    }, /*#__PURE__*/React.createElement(Title, null, item.title), /*#__PURE__*/React.createElement(Subtitle, null, item.subtitle))) : null;
  }))));
});
AgroHeaderTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    show: PropTypes.bool,
    url: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string
  })),
  tagManager: PropTypes.func
};
var headerWidth = '1152px';
var HeaderTabs = styled.div.withConfig({
  displayName: "AgroHeaderTabs__HeaderTabs",
  componentId: "e3refd-0"
})(["height:29px;background-color:", ";border-bottom:3px solid ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.green500;
});
var TabsArea = styled.div.withConfig({
  displayName: "AgroHeaderTabs__TabsArea",
  componentId: "e3refd-1"
})(["display:flex;height:100%;width:fit-content;@media (min-width:", "){width:", ";margin:auto;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.xl;
}, headerWidth);
var Content = styled.div.withConfig({
  displayName: "AgroHeaderTabs__Content",
  componentId: "e3refd-2"
})(["display:flex;height:100%;margin-left:11px;background-color:", ";width:fit-content;border-radius:8px 8px 0 0;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray100;
});
var Subtitle = styled.span.withConfig({
  displayName: "AgroHeaderTabs__Subtitle",
  componentId: "e3refd-3"
})(["display:inline-block;padding-left:5px;font-weight:400;"]);
var Title = styled.span.withConfig({
  displayName: "AgroHeaderTabs__Title",
  componentId: "e3refd-4"
})(["display:inline-block;font-weight:600;"]);
var Tab = styled.div.withConfig({
  displayName: "AgroHeaderTabs__Tab",
  componentId: "e3refd-5"
})(["padding-right:13px;padding-left:13px;display:flex;align-items:center;height:100%;background-color:", ";z-index:10;border-radius:8px 8px 0 0;margin-right:3px;position:relative;min-width:90px;&.active{background-color:", ";z-index:11;a{color:", ";}&:before,&:after{content:'';position:absolute;height:10px;width:20px;bottom:0;}&:after{right:-20px;border-radius:0 0 0 6px;-moz-border-radius:0 0 0 6px;-webkit-border-radius:0 0 0 6px;-webkit-box-shadow:-6px 0 0 0 ", ";box-shadow:-6px 0 0 0 ", ";}&:before{left:-20px;border-radius:0 0 6px 0;-moz-border-radius:0 0 6px 0;-webkit-border-radius:0 0 6px 0;-webkit-box-shadow:6px 0 0 0 ", ";box-shadow:6px 0 0 0 ", ";}}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.gray100;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green500;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.green500;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.green500;
}, function (_ref1) {
  var theme = _ref1.theme;
  return theme.colors.green500;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.green500;
});
var TabLink = styled.a.withConfig({
  displayName: "AgroHeaderTabs__TabLink",
  componentId: "e3refd-6"
})(["font-size:12px;line-height:21px;text-decoration:none;color:#595959;font-family:", ";> span{font-family:", ";font-size:12px;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily;
});
AgroHeaderTabs.displayName = 'AgroHeaderTabs';
export { AgroHeaderTabs };